/*!
 *
 * origin.js
 *
 */

var origin = {};

origin.ua = (function(u) {
	return {
		isTablet: (u.indexOf("windows") != -1 && u.indexOf("touch") != -1) ||
			u.indexOf("ipad") != -1 ||
			(u.indexOf("android") != -1 && u.indexOf("mobile") == -1) ||
			(u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1) ||
			u.indexOf("kindle") != -1 ||
			u.indexOf("silk") != -1 ||
			u.indexOf("playbook") != -1,
		isMobile: (u.indexOf("windows") != -1 && u.indexOf("phone") != -1) ||
			u.indexOf("iphone") != -1 ||
			u.indexOf("ipod") != -1 ||
			(u.indexOf("android") != -1 && u.indexOf("mobile") != -1) ||
			(u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1) ||
			u.indexOf("blackberry") != -1
	}
})(window.navigator.userAgent.toLowerCase());

origin.$window = $(window);
origin.wh = window.innerHeight;
origin.ww = window.innerWidth;
origin.wst = origin.$window.scrollTop();
origin.hash = location.hash;

if( origin.ww < 768 ){
	origin.viewport = 'mobile';
};

if( origin.ww >= 768 && origin.ww < 992 ){
	origin.viewport = 'tablet';
};

if( origin.ww >= 992 && origin.ww < 1200 ){
	origin.viewport = 'pc';
};

if( origin.ww >= 1200 ){
	origin.viewport = 'widepc';
};

origin.st = (function() {
	var elem;
	if ($.support.checkOn && $.support.noCloneChecked) {
		elem = 'html,body'; //FireFox
	} else {
		elem = 'html'; //Oprea IE9
	};
	if (origin.ua.isMobile || origin.ua.isTablet) {
		elem = 'html,body';
	};
	return elem;
})();


$(function() {
	origin.$window.on('resize', function() {
		origin.wh = window.innerHeight;
		origin.ww = window.innerWidth;
		if( origin.viewport !== 'mobile' && origin.ww < 768 ){
			origin.viewport = 'mobile';
			$(this).trigger('changeMobile');
			$(this).trigger('changeViewportMode');
		};
		if( origin.viewport !== 'tablet' && origin.ww >= 768 && origin.ww < 992 ){
			if( origin.viewport === 'mobile' ){
				$(this).trigger('changeSPtoTablet');
				$(this).trigger('changeViewportMode');
			};
			if( origin.viewport === 'pc' ){
				$(this).trigger('changePCtoTablet');
				$(this).trigger('changeViewportMode');
			};
			origin.viewport = 'tablet';
			$(this).trigger('changeTablet');
			$(this).trigger('changeViewportMode');
		};
		if( origin.viewport !== 'pc' && origin.ww >= 992 && origin.ww < 1200 ){
			origin.viewport = 'pc';
			$(this).trigger('changePC');
			$(this).trigger('changeViewportMode');
		};
		if( origin.viewport !== 'widepc' && origin.ww >= 1200 ){
			origin.viewport = 'widepc';
			$(this).trigger('changeWidePC');
			$(this).trigger('changeViewportMode');
		};
	});
});

module.exports = origin;


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/origin.js
// module id = 11
// module chunks = 0